import AxiosInstance from "../Utils/axios/axiosConfig";
import {
  getToken,
  removeAllDetailsFromCurrentSession,
  setRefreshToken,
  setToken,
  setUserEmailId,
} from "./localStorageServices";

export const authenticateUser = async (email = "", password = "") => {
  const response = await AxiosInstance.post("/authenticate/", {
    email,
    password,
  });
  if (!response.data.error) {
    setUserDetails(response.data.data, email);
  }
  return response;
};

const setUserDetails = ({ token_type, access_token, refresh_token }, email) => {
  setToken(`${token_type} ${access_token}`);
  setRefreshToken(refresh_token);
  setUserEmailId(email);
};

export const getUserProfile = async () => {
  const response = await AxiosInstance.get("/user-profile/");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getAllUsers = async (source = undefined) => {
  let response;
  if(source){
    response = await AxiosInstance.get("/deckleusers/",  {cancelToken: source.token});
  } else{
    response = await AxiosInstance.get("/deckleusers/");
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getSearchedUsers = async(pattern, source = undefined)=> {
  let response;
  if(source){
    response = await AxiosInstance.get("/deckleusers/?search", {
      params: {
        type: "contains",
        pattern: pattern,
      },
      cancelToken: source?.token
    });
  } else{
    response = await AxiosInstance.get("/deckleusers/?search", {
      params: {
        type: "contains",
        pattern: pattern,
      },
    });
  }  
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
}

export const getUserData = async (email) => {
  const response = await AxiosInstance.get("/deckleusers/", {
    params: { email: email },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const updateUserData = async (body) => {
  const response = await AxiosInstance.put("/deckleusers/",body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const inviteNewUser = async (data) => {
  const response = await AxiosInstance.post("/invite-user/", data);
  if (!response.data.error) {
    return response;
  } else {
    return Promise.reject(response);
  }
};

// export const logoutUser = async () => {

//   await AxiosInstance.post("/logout/");
//   removeAllDetailsFromCurrentSession();
// };

export const resetUserPassword = async (email = "", password = "") => {
  const response = await AxiosInstance.post("/reset-user-password/", {
    email,
    password,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const createAccount = async (
  email = "",
  name = "",
  newPassword = "",
  tempPassword = ""
) => {
  const response = await AxiosInstance.post("/create-account/", {
    email: email,
    temporary_password: tempPassword,
    new_password: newPassword,
    name: name,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const deleteUserAccount = async (id = "") => {
  const response = await AxiosInstance.post(`/delete-user/?id=${id}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const logoutUser = async () => {
  let token = getToken();
  token = token?.replace("Bearer ", "");
  const response = await AxiosInstance.post("/logout/", {
    access_token: token,
  });
  if (!response.data.error) {
    removeAllDetailsFromCurrentSession();
  }
  return response.data;
};

export const getFilteredUsers = async(filter, source = undefined)=> {
  let response;
  if(source){
    response = await AxiosInstance.post(`/deckleusers/filter/`, filter, {cancelToken: source?.token}); 
  } else{
    response = await AxiosInstance.post(`/deckleusers/filter/`, filter);
  }
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getCsrfToken = ()=> {
  return AxiosInstance.get(`/csrf-token/`);
}
